import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mtptd58squ: FaireBrandEntity = {
  token: "b_mtptd58squ",
  type: "brand",
  name: "Christian Brands Catholic",
  avatarUrl:
    "https://cdn.faire.com/fastly/fa81de100a09450d20603ba84509cf898076bdb4e715f1b53bd46be5a027a1bc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e918ea0bfd1edccb4d0b3ed6dc6886997af1e0c6991c4c0af091a6365e68fe58.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fa81de100a09450d20603ba84509cf898076bdb4e715f1b53bd46be5a027a1bc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e918ea0bfd1edccb4d0b3ed6dc6886997af1e0c6991c4c0af091a6365e68fe58.png",
  location: "Phoenix, AZ, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 133,
  isInsider: true,
  description:
    "Christian Brands Catholic was born out of the wish to create trade exclusive, religious gift products that express the spirit and enhance the faith of the Catholic community. For more than 60 years, we have served the religious retailing community. We are a Catholic owned and operated company with a heritage rich in tradition and a committment to offering retailers the finest selection of religious gifts backed by superior customer service.\n\nOur product offerings feature traditional statuary, sacramental gifts, hundreds of rosaries and devotional items, as well as many exquisite uniquely Catholic gifts. We have traveled extensively throughout the world to design and source exclusive, quality religious products at affordable prices. We take pride in the fact that we are a premier source for religious gifts that support the Catholic community and help people of all cultures celebrate their Catholic heritage. We know you have a choice when purchasing product and we very much appreciate your continued patronage.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:12.388Z",
    importedBy: "entity-db-cli",
  },
};
